import React from "react";

const CookiePolicy = () => {
  return (
    <div className="p-4 mx-auto">
      {/* <h1 className="text-3xl font-bold mb-4">Cookie Policy</h1> */}
      <p className="text-gray-600">Effective Date: 1 January 2025</p>

      <p>
        At FindNigeriaProperties.com (&quot;we,&quot; &quot;our,&quot; or
        &quot;us&quot;), we use cookies and similar technologies to enhance your
        experience on our platform (&quot;Platform&quot;). This Cookie Policy
        explains what cookies are, how we use them, and how you can manage your
        preferences.
      </p>

      <h2 className="text-2xl font-semibold mt-6">1. What Are Cookies?</h2>
      <p>
        Cookies are small text files stored on your device (computer,
        smartphone, tablet) by websites you visit. They enable websites to
        recognize your device, store preferences, and improve functionality and
        user experience.
      </p>

      <h2 className="text-2xl font-semibold mt-6">
        2. Types of Cookies We Use
      </h2>

      <h3 className="text-xl font-medium mt-4">2.1. Essential Cookies</h3>
      <p>
        These cookies are necessary for the Platform to function properly and
        cannot be disabled. They enable core features such as account login,
        secure transactions, and navigation.
      </p>
      <ul className="list-disc pl-6">
        <li>Session cookies to maintain your login status.</li>
        <li>Security cookies to protect against fraudulent activity.</li>
      </ul>

      <h3 className="text-xl font-medium mt-4">2.2. Performance Cookies</h3>
      <p>
        These cookies help us understand how users interact with the Platform by
        collecting anonymous data. This allows us to improve performance and
        user experience.
      </p>
      <ul className="list-disc pl-6">
        <li>Analytics cookies that track page visits and user behavior.</li>
      </ul>

      <h3 className="text-xl font-medium mt-4">2.3. Functional Cookies</h3>
      <p>
        These cookies remember your preferences and settings to provide a more
        personalized experience.
      </p>
      <ul className="list-disc pl-6">
        <li>Language and region preferences.</li>
        <li>Remembering your login details for future visits.</li>
      </ul>

      <h3 className="text-xl font-medium mt-4">
        2.4. Targeting/Advertising Cookies
      </h3>
      <p>
        These cookies are used to deliver relevant advertisements and track the
        effectiveness of our marketing campaigns. They may also limit the number
        of times you see a particular ad.
      </p>
      <ul className="list-disc pl-6">
        <li>
          Cookies that track your browsing history to show personalized ads.
        </li>
        <li>Cookies set by third-party advertising partners.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">3. Third-Party Cookies</h2>
      <p>
        We may allow third-party service providers, such as analytics and
        advertising partners, to place cookies on your device. These cookies are
        governed by the privacy policies of the respective third parties.
      </p>
      <p>Examples of third-party services we use:</p>
      <ul className="list-disc pl-6">
        <li>Google Analytics</li>
        <li>Facebook Pixel</li>
        <li>Ad networks for personalized advertising</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">4. How We Use Cookies</h2>
      <ul className="list-disc pl-6">
        <li>Ensure the smooth operation of the Platform.</li>
        <li>Understand user behavior and improve the Platform.</li>
        <li>Personalize content and advertising.</li>
        <li>Enhance security and prevent fraudulent activity.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">
        5. Managing Your Cookie Preferences
      </h2>
      <p>
        You can manage or disable cookies through your browser settings.
        However, please note that disabling essential cookies may impact the
        functionality of the Platform.
      </p>
      <p>Steps to manage cookies:</p>
      <ol className="list-decimal pl-6">
        <li>Open your browser’s settings.</li>
        <li>
          Navigate to the &quot;Privacy&quot; or &quot;Cookies&quot; section.
        </li>
        <li>Adjust your cookie preferences or delete existing cookies.</li>
      </ol>

      <p>
        For more detailed instructions, refer to your browser&apos;s help
        documentation:
      </p>
      <ul className="list-disc pl-6">
        <li>Google Chrome</li>
        <li>Mozilla Firefox</li>
        <li>Safari</li>
        <li>Microsoft Edge</li>
      </ul>

      <p>
        Alternatively, you can use tools like the{" "}
        <a
          href="https://www.youronlinechoices.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500"
        >
          Your Online Choices
        </a>{" "}
        platform to manage cookie preferences.
      </p>

      <h2 className="text-2xl font-semibold mt-6">6. Cookie Duration</h2>
      <ul className="list-disc pl-6">
        <li>
          <strong>Session Cookies:</strong> Deleted when you close your browser.
        </li>
        <li>
          <strong>Persistent Cookies:</strong> Remain on your device for a
          specified period or until manually deleted.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">
        7. Updates to This Cookie Policy
      </h2>
      <p>
        We may update this Cookie Policy from time to time to reflect changes in
        our practices or legal requirements. Updates will be communicated via
        email or Platform notifications, and the &quot;Effective Date&quot; will
        be updated accordingly.
      </p>

      <h2 className="text-2xl font-semibold mt-6">8. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Cookie Policy, please
        contact us:
      </p>
      <p>
        Email:{" "}
        <a
          href="mailto:compliance@FindNigeriaProperties.com"
          className="text-blue-500"
        >
          compliance@FindNigeriaProperties.com
        </a>
        <br />
        Phone: +234 (806) 070 6906
        <br />
        Address: 7th Floor, CBC Towers, Lekki Phase 1, Lekki
      </p>

      <p className="mt-6">
        By using FindNigeriaProperties.com, you consent to the use of cookies as
        described in this policy. If you do not agree, please adjust your
        browser settings or refrain from using the Platform.
      </p>
    </div>
  );
};

export default CookiePolicy;
